import { isValid } from 'date-fns';

import { Filter } from '../types';

// parse date to ISO string
// and transform outletIds inside filter to array of string
function transformFilter(filter?: Filter) {
  if (filter) {
    const { outletIds, startDate, endDate } = filter;

    return {
      ...filter,
      ...(startDate && isValid(new Date(startDate)) ? { startDate: new Date(startDate).toISOString() } : {}),
      ...(endDate && isValid(new Date(endDate)) ? { endDate: new Date(endDate).toISOString() } : {}),
      ...((outletIds || []).length > 0 ? { outletIds: outletIds?.map((id: number) => String(id)) } : {}),
    };
  }

  return filter;
}

export { transformFilter };
